import { createSelector } from 'reselect';
import _ from 'lodash';

import { VERSION } from 'utils/campaign';
import { PLAN_CODE } from 'utils/user';
import { selectIsCampaignOpen } from 'services/reducers/campaignReducer';

export const selectIsSocialEcomm = createSelector(
  (state) => state.userState.planCode,
  (state, props) => props.version,
  (state, props) => props.flags,
  (state) => state.campaignState.socialWindow,
  (planCode, version, flags, socialWindow) => {
    const isMember =
      planCode === PLAN_CODE.fffvip || planCode === PLAN_CODE.fffvipa;
    const isRedeemed = planCode === PLAN_CODE.fffsocial;
    const { socialEcomm: socialEcommFF } = flags;
    const isEditPage = version === VERSION.edit;
    const isSocialEcomm =
      isEditPage && socialEcommFF && socialWindow && (isMember || isRedeemed);
    return !!isSocialEcomm;
  }
);

export const selectDisplaySocialBanner = createSelector(
  (state) => state.userState.userId,
  (state) => state.userState.planCode,
  (state) => state.socialEcommState.team.teamId,
  (state) => selectIsCampaignOpen(state),
  (state, props) => selectIsSocialEcomm(state, props),
  (userId, planCode, teamId, campaignIsOpen, isSocialEcomm) => {
    const isMember =
      planCode === PLAN_CODE.fffvip || planCode === PLAN_CODE.fffvipa;
    const isRedeemed = planCode === PLAN_CODE.fffsocial;
    const displaySocialBanner =
      campaignIsOpen && isSocialEcomm && ((isMember && !teamId) || isRedeemed);
    return displaySocialBanner;
  }
);

export const selectTeamCartProducts = createSelector(
  (state) => state.socialEcommState.teamCart.cartProducts,
  (state) => state.socialEcommState.teamCart.userIds,
  (state) => state.socialEcommState.socialAvatars,
  (cartProducts, userIds, socialAvatars) => {
    if (
      !_.isEmpty(cartProducts) &&
      !_.isEmpty(userIds) &&
      !_.isEmpty(socialAvatars)
    ) {
      const populatedSocialAvatars = _.reduce(
        userIds,
        (result, value) => {
          const user = _.find(socialAvatars, (item) => item.userId === value);
          return {
            ...result,
            [value]: user || {
              userAvatarUrl: '',
              username: '',
              userId: value,
            },
          };
        },
        {}
      );
      const populatedCartProducts = _.reduce(
        cartProducts,
        (result, value, key) => {
          const team = _.map(value, (id) => populatedSocialAvatars[id]);
          return {
            ...result,
            [key]: team,
          };
        },
        {}
      );
      return populatedCartProducts;
    }
    return {};
  }
);
